import React from 'react'
import EditMenu from '../../../../components/organisms/admin/menu/special/EditMenu'

type Props = {}

const EditMenuPage = (props: Props) => {
  return (
    <EditMenu />
  )
}

export default EditMenuPage